module.exports = __webpack_public_path__ + "static/scenes-solutions-4-f917374f0a13f16d9ec88dd600f4a0fa.png";